import PropTypes from 'prop-types';

import { DashboardLayout } from '../../layouts';
import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import Helmet from '../../components/Helmet';
import PendingState from '../../components/PendingState';
import { webPaths } from '../../routes/paths';
import { globalColours } from '@classity-edtech/ui-base/dist/style/source';
import { ArrowRightIcon } from '@classity-edtech/ui-base/dist/components/Displays';

export interface TutorPrivateTuitionProps extends MuiBoxProps {}

export const TutorPrivateTuition = ({ className }: TutorPrivateTuitionProps) => {
  return (
    <>
      <Helmet />
      <DashboardLayout>
        <Stack sx={{ gap: 3 }}>
          <Link
            to={`/${webPaths.tutorDashboard}`}
            style={{ textDecoration: 'none', width: 'fit-content', cursor: 'pointer' }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: 3,
                items: 'center',
                color: globalColours['$global-colour-content-primary'],
                cursor: 'pointer',
              }}
            >
              <ArrowRightIcon
                sx={{ width: '32px', height: '32px', transform: 'rotate(180deg)', mt: '-4px' }}
              />
              <Typography variant='subtitle3'>Private Tuition</Typography>
            </Box>
          </Link>

          <PendingState />
        </Stack>
      </DashboardLayout>
    </>
  );
};

TutorPrivateTuition.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

TutorPrivateTuition.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(TutorPrivateTuition)(
  ({ theme }) => `
`,
);
